export const ADVANCED_FIELD_KEYS = [
  'EvidenceID',
  'IncidentID',
  'TagNumber',
  'CollectedBy',
  'LocationCollected',
  'Make',
  'Model',
  'SerialNumber',
  'VIN',
  'LicenseNumber',
  'SubstanceType',
  'SubstanceClass',
  'StorageLocation',
  'SubLocation',
  'Container',
  'disposalCode',
  'offense',
  'FinalDisposition',
  'PartyType',
  'PartyName',
];

export const FILTER_FIELD_KEYS = [
  'searchText',
  'submittedDate',
  'requiredActionDate',
  'searchTextDraft',
  'propertyType',
  'category',
  'evidenceType',
  'tempLocation',
  'currentLocation',
  'submittedBy',
  'requiredAction',
  'status',
  'hasCorrection',
  'correctionStatus',
  'correctionReason',
  'correctionRoutedTo',
  'overdue',
  ...ADVANCED_FIELD_KEYS,
  'collectedDate',
  'dispositionDate',
];

export const EVIDENCE_RECORDS_DEFAULT_VALUES = {
  searchText: [],
  searchTextDraft: '',
  submittedDate: { from: null, to: null },
  requiredActionDate: { from: null, to: null },
  propertyType: [],
  category: [],
  evidenceType: [],
  tempLocation: [],
  currentLocation: [],
  submittedBy: [],
  requiredAction: [],
  status: [],
  hasCorrection: '',
  correctionStatus: [],
  correctionReason: [],
  correctionRoutedTo: [],
  overdue: false,
  EvidenceID: [],
  IncidentID: [],
  TagNumber: [],
  CollectedBy: [],
  LocationCollected: [],
  Make: [],
  Model: [],
  SerialNumber: [],
  VIN: [],
  LicenseNumber: [],
  SubstanceType: [],
  SubstanceClass: [],
  StorageLocation: [],
  SubLocation: [],
  Container: [],
  disposalCode: [],
  offense: [],
  collectedDate: { from: null, to: null },
  FinalDisposition: [],
  dispositionDate: { from: null, to: null },
  PartyType: [],
  PartyName: '',
};

export const EVIDENCE_RECORDS_EMPTY_STATS = {
  _total: 0,
  _overdue: 0,
};

export const EVIDENCE_RECORDS_LAZY_FIELD_CONFIG = [
  ['EvidenceID', 'Evidence ID'],
  ['IncidentID', 'Incident Number'],
  ['TagNumber', 'Tag Number'],
  ['SerialNumber', 'Serial Number'],
  ['VIN', 'VIN'],
  ['LicenseNumber', 'Plate / License'],
  ['CollectedBy', 'Collected By', 'CollectedByPersonID'],
  ['LocationCollected', 'Location Collected'],
];

export const EVIDENCE_RECORDS_FIELD_CONFIG = [
  ['Make', 'Make'],
  ['Model', 'Model'],
];

export const PARTY_TYPE_ENTITY = 'Evidence';

export const EVIDENCE_CORRECTION_STATUS_REF_CATEGORY = 'CorrectionRequest';
export const DEFAULT_PAGE = 0;
export const DEFAULT_PAGE_SIZE = 25;
